import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsApp() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">

      {/* CHAT BOX */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.9 }}
            className="w-80 bg-white rounded-3xl shadow-2xl border border-black/10 overflow-hidden"
          >
            
            {/* HEADER */}
            <div className="bg-green-500 text-white p-4 flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <FaWhatsapp className="text-green-500" />
              </div>

              <div>
                <p className="font-bold text-sm">Aysu Groups</p>
                <p className="text-xs flex items-center gap-1">
                  <span className="w-2 h-2 bg-green-300 rounded-full"></span>
                  Online
                </p>
              </div>
            </div>

            {/* BODY */}
            <div className="p-4 text-sm text-slate-700">
              <p className="bg-slate-100 p-3 rounded-xl inline-block">
                👋 Hi there! <br />
                How can we help you today?
              </p>
            </div>

            {/* BUTTON */}
            <div className="p-4">
              <a
                href="https://wa.me/919361226606?text=Hello%20Aysu%20Groups,%20I%20need%20your%20service"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition"
              >
                Start Chat
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* FLOATING BUTTON */}
      <motion.button
        onClick={() => setOpen(!open)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="relative w-16 h-16 rounded-full 
        bg-gradient-to-br from-green-500 to-emerald-600 
        text-white flex items-center justify-center shadow-xl"
      >
        <FaWhatsapp size={28} />

        {/* Notification dot */}
        <span className="absolute top-2 right-2 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
      </motion.button>

    </div>
  );
}